<template>
  <div class="column">
    <div class="ui top attached menu">
      <div class="ui dropdown icon item" ref="module_dropdown">
        <i class="shoe prints icon"></i>
        <div class="menu">
          <div class="ui dropdown icon item">
            <i class="sliders horizontal icon"></i>
            {{ $t("configure") }}
          </div>
        </div>
      </div>
      <div class="ui dropdown icon item">
        {{ stage.name }} - {{ stage.weighting_percent }}%
      </div>
      <div class="right menu">
        <div
          class="ui dropdown icon item"
          style="padding: 0px 11px;"
          @click="remove_stage"
        >
          <div class="button" :data-tooltip="$t('remove')">
            <i class="red trash icon" style="margin: 0"></i>
          </div>
        </div>
        <div class="ui dropdown icon item" @click="add_task">
          <i
            class
            v-bind:class="{
              'expand icon': this.compressed,
              'compress icon': !this.compressed,
            }"
          ></i>
        </div>
        <div class="ui dropdown icon item" @click="add_task">
          <i class="green plus icon" style="margin: 0"></i>
        </div>
      </div>
    </div>
    <div class="ui bottom attached segment" ref="main_segment">
      <div class="ui form">
        <div class="fields">
          <div class="eight wide field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" name="" v-model="stage.name" />
          </div>
          <div class="five wide field">
            <label for="">{{ $t("weighting") }} (%)</label>
            <input type="text" name="" v-model="stage.weighting_percent" />
          </div>
          <div class="three wide field">
            <label>{{ $t("extra") }}</label>
            <div class="ui toggle checkbox">
              <input type="checkbox" name="example" v-model="stage.extra" />
              <label></label>
            </div>
          </div>
        </div>
      </div>
      <h4 class="ui dividing header">{{ $t("activities") }}</h4>
      <div
        class="ui error message"
        style="display: inline-block"
        v-if="task_weighting_summation > 100"
      >
        <div class="header">
          {{ $t("limit overflow") }}
        </div>
        <p>
          {{ $t("weighting summation is above limit, check tasks weighting") }}
        </p>
      </div>
      <div class="ui form">
        <div class="fields" v-for="(task, idx) in stage.tasks" :key="idx">
          <div class="ten wide field">
            <label for="" v-if="idx == 0">{{ $t("name") }}</label>
            <input type="text" name="" v-model="stage.tasks[idx].name" />
          </div>
          <div class="four wide field">
            <label for="" v-if="idx == 0">{{ $t("weighting") }} (%)</label>
            <input
              type="text"
              name=""
              v-model="stage.tasks[idx].weighting_percent"
            />
          </div>
          <div class="two wide field">
            <label for="" v-if="idx == 0">{{ $t("options") }}</label>
            <div class="ui basic icon button" @click="remove_task(idx)">
              <i class="red trash icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="ui info message"
        style="display: inline-block"
        v-if="task_weighting_summation < 100"
      >
        <div class="header">
          {{ $t("weighting incomplete") }}
        </div>
        <p>
          {{ $t("weighting summation is incomplete, check tasks weighting") }}
        </p>
      </div>
    </div>

    <!-- <generic-view
      class="column"
      :title="stage.name + ' - ' + stage.weighting_percent + '%'"
      icon="shoe prints"
      v-bind:show_plus="true"
      v-on:add="add_task"
      :header_buttons="header_buttons"
    >
      <div class="ui form">
        <div class="fields">
          <div class="ten wide field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" name="" v-model="stage.name" />
          </div>
          <div class="six wide field">
            <label for="">{{ $t("weighting") }} (%)</label>
            <input type="text" name="" v-model="stage.weighting_percent" />
          </div>
        </div>
      </div>
      <h4 class="ui dividing header">{{ $t("tasks") }}</h4>
      <div
        class="ui error message"
        style="display: inline-block"
        v-if="task_weighting_summation > 100"
      >
        <div class="header">
          {{ $t("limit overflow") }}
        </div>
        <p>
          {{ $t("weighting summation is above limit, check tasks weighting") }}
        </p>
      </div>
      <div class="ui form">
        <div class="fields" v-for="(task, idx) in stage.tasks" :key="idx">
          <div class="ten wide field">
            <label for="" v-if="idx == 0">{{ $t("name") }}</label>
            <input type="text" name="" v-model="stage.tasks[idx].name" />
          </div>
          <div class="four wide field">
            <label for="" v-if="idx == 0">{{ $t("weighting") }} (%)</label>
            <input
              type="text"
              name=""
              v-model="stage.tasks[idx].weighting_percent"
            />
          </div>
          <div class="two wide field">
            <label for="" v-if="idx == 0">{{ $t("options") }}</label>
            <div class="ui basic icon button" @click="remove_task(idx)">
              <i class="red trash icon"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="ui info message"
        style="display: inline-block"
        v-if="task_weighting_summation < 100"
      >
        <div class="header">
          {{ $t("weighting incomplete") }}
        </div>
        <p>
          {{ $t("weighting summation is incomplete, check tasks weighting") }}
        </p>
      </div>
    </generic-view> -->
  </div>
</template>

<script>
// import GenericView from "@/components/GenericContainer";

export default {
  name: "CourseScoringEditWeightingStage",
  components: {
    // "generic-view": GenericView,
  },
  props: {
    stage: Object,
  },
  data() {
    return {
      //   header_buttons: [{ icon: "red trash", click: this.remove_stage }],
      compressed: false,
    };
  },
  computed: {
    task_weighting_summation() {
      return this.stage.tasks.reduce((prev, curr) => {
        return prev + Number(curr.weighting_percent);
      }, 0);
    },
  },
  methods: {
    remove_task(index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove task?"), function() {
        vm.stage.tasks.splice(index, 1);
      });
    },
    add_task() {
      let vm = this;
      vm.stage.tasks.push({
        name: vm.$t("task") + vm.stage.tasks.length,
        weighting_percent: 0,
      });
    },
    remove_stage() {
      this.$emit("remove_stage", this.stage);
      //   let vm = this;
      //   vm.$alertify.confirm(vm.$t("are you sure to remove stage?"), function() {
      //     vm.emt();
      //   });
    },
    toggle() {
      this.compressed = !this.compressed;
      window.jQuery(this.$refs.main_segment).slideToggle("fast");
    },
    // emt() {
    //   this.$emit("remove_stg", this.stage);
    // },
  },
};
</script>
